import { useGetTicketSaleTargetsQuery } from 'Services/SalesManagement/Features/TicketSale/ticketSaleApi'
import type { FetchTicketSaleTargetListParams } from 'Services/SalesManagement/Features/TicketSale/types'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

export const SELECTED_TICKET_SALE_TARGET_PARAMETER_KEY = 'selectedTicketSaleTarget'

export function useTicketSaleTargetsWithParams() {
  const [searchParams, setSearchParams] = useSearchParams()

  const [params, setParams] = useState<FetchTicketSaleTargetListParams>({
    ordering: searchParams.get('ordering') ?? '-created',
    page: searchParams.get('page') ? parseInt(searchParams.get('page') as string) : 1
  })

  const { data, isFetching } = useGetTicketSaleTargetsQuery(params)

  const selectedTicketSaleTargetQueryParam =
    searchParams.get(SELECTED_TICKET_SALE_TARGET_PARAMETER_KEY) ?? undefined

  const [selectedTicketSaleTargetId, setSelectedTicketSaleTargetId] = useState(
    selectedTicketSaleTargetQueryParam
  )

  const setQueryParams = () => {
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        searchParams.set(key, value.toString())
      } else {
        searchParams.delete(key)
      }
    })

    if (selectedTicketSaleTargetId) {
      searchParams.set(SELECTED_TICKET_SALE_TARGET_PARAMETER_KEY, selectedTicketSaleTargetId)
    }

    setSearchParams(searchParams)
  }

  useEffect(() => {
    setQueryParams()
  }, [params])

  useEffect(() => {
    if (selectedTicketSaleTargetId) {
      setQueryParams()
    } else {
      searchParams.delete(SELECTED_TICKET_SALE_TARGET_PARAMETER_KEY)
      setSearchParams(searchParams)
    }
  }, [selectedTicketSaleTargetId])

  return {
    data,
    isFetching,
    params,
    setParams,
    selectedTicketSaleTargetId,
    setSelectedTicketSaleTargetId
  }
}

export default useTicketSaleTargetsWithParams
